import { apiTokensApi } from "./apiTokens";

export const { useGetApiTokensQuery, useCreateApiTokenMutation } = apiTokensApi;
